import React, { useContext, useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { FormControl, RangeSlider } from 'rsuite';
import { useDebouncedCallback } from 'use-debounce';
import { fetchFilterMinMax } from '../api';
import { useLocation } from '../hooks/useLocation';
import { EquipmentContext } from '../utils/scope';

export const FilterSlider = ({ name }) => {
  const { params, go } = useLocation();
  const scope = useContext(EquipmentContext);
  const [v, setV] = useState('');

  const { category, page, order, view, ...filters } = params;

  let filtersServer = { ...filters };
  delete filtersServer[name];

  const { status, data, error } = useQuery(
    [scope, 'min-max', name, category, filtersServer],
    fetchFilterMinMax,
  );

  const update = useDebouncedCallback((v) => {
    const vals = { [name]: v };

    go({ ...params, ...vals });
  }, 500);

  useEffect(() => update.callback(v), [update, v]);

  if (status === 'loading') {
    return (
      <FormControl className="filter" progress disabled accepter={RangeSlider} min={0} max={0} />
    );
  }

  if (status === 'error') {
    return <span>Error: {error.message}</span>;
  }

  const value = v ? v.toString().split(',') : [data.min, data.max];

  value[0] = parseInt(value[0], 10);
  value[1] = parseInt(value[1], 10);

  if (value[0] < data.min) value[0] = data.min;
  if (value[1] > data.max) value[1] = data.max;

  return (
    <FormControl
      className="filter"
      accepter={RangeSlider}
      min={data.min}
      max={data.max}
      progress
      value={value}
      onChange={(v) => {
        let vv = v ? v.join(',') : null;

        if (v[0] === data.min && v[1] === data.max) {
          vv = null;
        }

        setV(vv);
      }}
    />
  );
};
